import { render, staticRenderFns } from "./GetItemEffect.vue?vue&type=template&id=673c0471&"
import script from "./GetItemEffect.vue?vue&type=script&lang=ts&"
export * from "./GetItemEffect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports